import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

interface RightActionBlockHeaderProps {
  actions?: ReactNode;
  className?: string;
  title: string;
}

export const RightActionBlockHeader = ({
  title,
  actions,
  className,
}: RightActionBlockHeaderProps) => (
  <div
    className={classNames(
      "flex shrink-0 items-center justify-between px-6 pt-4 pb-3",
      className,
    )}
  >
    <Typography variant="heading-lg">{title}</Typography>
    {actions && <div className="flex items-center gap-1">{actions}</div>}
  </div>
);
